<div class="bg-white container-lg ">
  <main role="main" class="col-md-12 mb-4 pb-2 pt-4">

    <form [formGroup]="entityForm" (ngSubmit)="onSubmit()" class="mb-5">
      <div>
        <formly-form [model]="model"
                     [fields]="fields"
                     [options]="options"
                     [form]="entityForm">
        </formly-form>
      </div>
      <div class="mt-3">
        <button type="submit" [disabled]="!entityForm.valid" class="btn btn-primary me-3">{{label['save']}}</button>
        <button type="button" class="btn btn-light" (click)="cancelFormSubmit()">{{label['cancel']}}</button>
      </div>
    </form>

  </main>
</div>


<!--<div class="bg-white container-lg ">-->
<!--  <main role="main" class="col-md-12 mb-4 pb-2 pt-4">-->

<!--    <form [formGroup]="entityForm" (submit)="onEntityFormSubmit()">-->
<!--      <ng-container *ngIf="entityformconfig">-->
<!--        <h4>Edit "{{ entity[entitylabelkey] }}"</h4>-->

<!--        <ng-container *ngFor="let element of getFormConfigs()">-->

<!--          <ng-container *ngIf="element['fieldtype']==='text'">-->
<!--            <div class="form-group">-->
<!--              <label>{{element['fieldlabel']}} <span *ngIf="element['language']" class="badge bg-light">{{element['language']}}</span></label>-->
<!--              <input type="text" class="form-control" formControlName="{{element['field']}}"-->
<!--                     [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"-->
<!--                     [readonly]="element['readonly']"-->

<!--                     [class.myClass]-->
<!--              />-->
<!--              <div class="invalid-feedback">-->
<!--                Mandatory {{element['field']}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </ng-container>-->

<!--          <ng-container *ngIf="element['fieldtype']==='password'">-->
<!--            <div class="form-group">-->
<!--              <label>{{element['fieldlabel']}} <span *ngIf="element['language']" class="badge bg-light">{{element['language']}}</span></label>-->
<!--              <ng-container *ngIf="element['fieldtip']!==''">-->
<!--                <button type="button" class="btn btn-light"-->
<!--                        tooltip="{{element['fieldtip']}}">-->
<!--                  <svg class="bi bi-info-circle-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path fill-rule="evenodd" d="M8 16A8 8 0 108 0a8 8 0 000 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>-->
<!--                  </svg>-->
<!--                </button>-->
<!--              </ng-container>-->
<!--              <div class="input-group">-->
<!--                <input [type]="element['showpwd'] ? 'text' : 'password'" class="form-control" formControlName="{{element['field']}}" data-toggle="password"-->
<!--                       [ngClass]="{'is-invalid': isFieldWithError(element['field']) || isFalse }"-->
<!--                       [readonly]="element['readonly']" (change)="isPasswordRigth()"-->
<!--                />-->
<!--                <div class="input-group-append">-->
<!--                  <div class="input-group-text"><i class="fa" [ngClass]="{-->
<!--                    'fa-eye-slash': !element['showpwd'],-->
<!--                    'fa-eye': element['showpwd']}"-->
<!--                    (click)="toggleFieldTextType(element)"></i></div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="invalid-feedback">-->
<!--                Mandatory {{element['field']}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </ng-container>-->

<!--          <ng-container *ngIf="element['fieldtype']==='select'">-->
<!--            <div class="form-group">-->
<!--              <label>{{element['fieldlabel']}}</label>-->
<!--              <select class="form-control" formControlName="{{element['field']}}"-->
<!--                      [ngClass]="{'is-invalid': isFieldWithError(element['field'])}" >-->
<!--                <option *ngFor="let item of element['choices']" value="{{item['id']}}">-->
<!--                  {{item['label']}}-->
<!--                </option>-->
<!--              </select>-->
<!--              <div class="invalid-feedback">-->
<!--                Mandatory {{element['field']}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </ng-container>-->
<!--        </ng-container>-->

<!--        <div class="row no-gutters my-4">-->
<!--          <div class="col-12 my-1 text-end">-->
<!--            <button type="button" class="btn btn-secondary me-2" (click)="cancelFormSubmit()">Cancel</button>-->
<!--            <button type="submit" class="btn btn-primary">Update</button>-->
<!--          </div>-->
<!--        </div>-->

<!--      </ng-container>-->

<!--      <ng-container *ngIf="!entityid">-->
<!--        <p>Profil not found</p>-->
<!--      </ng-container>-->

<!--    </form>-->


<!--  </main>-->
<!--</div>-->

